import React, {Component, Fragment} from 'react';
import DEFINE, {HOTEL as ENUM_HOTEL, PATHS, FEATURE_FLAGS} from "../../../../constants/Define";
import {Link} from 'react-router-dom';
import * as Func from '../../../../helpers/functions';
import * as HMS from "../../common/component/Index";
import PageList from './PageList';
import Ripple from '../../common/component/Ripple';

let permisionActions = [];
export default class Pages extends Component {
    constructor(props) {
        super(props);
        this.state = {
            filters: {
                pageSize: this.props.pageState.pageSize,
                pageIndex: this.props.pageState.pageIndex,
            },
        };
    }

    componentDidMount() {
        permisionActions = Func.getPermissionActions(DEFINE.GENERAL.ROUTE_NAME.PAGE);
        this.props.getListPages(this.state.filters);
    }

    render() {
        const {t} = this.props;
        const {isFetching, totalCount, totalPage, pageIndex, pageSize, pages} = this.props.pageState;
        const pagination = {totalCount, totalPage, defaultCurrent: pageIndex, pageSize};
        return (
            <Fragment>
                <HMS.PageListComponent onChangeLanguage={FEATURE_FLAGS.TRANSLATE_ENABLE && this.onChangeLanguage}>
                    <HMS.HeaderListComponent
                        path={this.props.match.path}
                        groupPath={'pages'}
                        titleHeader={t('navigation.pages')}
                        componentRight={
                            <Fragment>{
                                permisionActions && permisionActions.allowCreate &&
                                <Ripple color="rgba(255, 255, 255, 0.8)" waitForEffect={true}>
                                    <Link to={PATHS.PAGE.CREATE.path}
                                          className='btn btn-primary'>+ {t(`action.create`)}</Link>
                                </Ripple>
                            }
                            </Fragment>
                        }
                    />
                    <PageList loading={isFetching}
                                  permisions={permisionActions}
                                  pages={pages}
                                  pagination={pagination}
                                  onChange={this.onTableChange}
                                  onDeletePage={this.onDeletePage}
                    />
                </HMS.PageListComponent>
            </Fragment>
        );
    }

    onTableChange = (pagination, filters, sorter) => {
        let newFilters = Func.genaratePaginateFilterSort(pagination, filters, sorter);
        this.setState({
            filters: newFilters
        });
        this.props.getListPages(newFilters);
    };

    onDeletePage = (item) => {
        this.props.deletePageDetail(item, {
            filters: {
                pageSize: this.props.pageState.pageSize,
                pageIndex: this.props.pageState.pageIndex
            }
        });
    }

    onChangeLanguage = (language) => {
        this.props.getListPages(this.state.filters)
    }

}
